import React, { useState } from "react";
import "./Search.css";
import NavBar from "../../components/browse/NavBar";
import SearchForm from "../../components/search/SearchForm";
import ResultList from "../../components/search/ResultList";
import requests from "../../utils/requests";
const Search = () => {
  const baseUrl = "https://api.themoviedb.org/3";
  const [results, setResults] = useState([]);
  //serch phim theo query
  const handleSearch = async (query) => {
    if (!query) return;
    try {
      const response = await fetch(
        `${baseUrl}${requests.fetchSearch}&query=${encodeURIComponent(query)}`
      );
      const data = await response.json();
      setResults(data.results);
    } catch (error) {
      console.error("Failed to fetch movies:", error);
    }
  };
  return (
    <div className="app">
      <NavBar />
      <SearchForm onSearch={handleSearch} />
      <ResultList results={results} />
    </div>
  );
};

export default Search;
